module.exports = __webpack_public_path__ + "img/luxestyle-promotion.60c56f5c.png";